import { AlertModal, AlertModalProps } from '@musinsa/mwms-ds'

export function AlertModalList({ list, destroy }: { list: Omit<AlertModalProps, 'open'>[]; destroy: (id: string) => void }) {
  return (
    <>
      {!list.length
        ? null
        : list.map((alert) => (
            <AlertModal
              open
              closable
              {...alert}
              type="alert"
              key={`moms-alert-modal-${alert.id}`}
              onClose={() => {
                if (alert.onClose) alert.onClose()
                destroy(alert.id || '')
              }}
            />
          ))}
    </>
  )
}

export function ConfirmModalList({ list, destroy }: { list: Omit<AlertModalProps, 'open'>[]; destroy: (id: string) => void }) {
  return (
    <>
      {list.length
        ? list.map((confirm) => (
            <AlertModal
              open
              {...confirm}
              type="confirm"
              key={`moms-confirm-modal-${confirm.id}`}
              onClose={() => {
                if (confirm.onClose) confirm.onClose()
                destroy(confirm.id || '')
              }}
            />
          ))
        : null}
    </>
  )
}

export default AlertModal
